module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#twitter",
      toString: function () {
        return this.url;
      }
    }